module.exports = __webpack_public_path__ + "img/stock0.3d85aba4.png";